import Modal from "@/components/Modal";
import PhotoUpload from "@/components/PhotoUpload";
import { Save } from "lucide-react";
import { KECAMATAN_MAGELANG } from "@/lib/api";
import { useState } from "react";

const RULES = {
  name: (v) => !v?.trim() ? "Nama wajib" : v.trim().length < 2 ? "Minimal 2 karakter" : "",
  email: (v) => !v?.trim() ? "Email wajib" : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()) ? "" : "Format email tidak valid",
  username: (v) => !v ? "" : /^[a-z0-9_.]{3,30}$/.test(v.trim().toLowerCase()) ? "" : "3-30, huruf kecil, angka, . _",
  password: (v) => !v ? "Password wajib" : v.length < 8 ? "Minimal 8 karakter" : "",
  whatsapp: (v) => {
    if (!v?.trim()) return "WA wajib";
    if (/[^\d+\s-]/.test(v.trim())) return "Hanya boleh angka (tanda + di awal)";
    const d = v.replace(/\D/g, "");
    if (d.length < 9 || d.length > 15) return "9-15 digit";
    return "";
  },
  address: (v) => !v?.trim() ? "Alamat wajib" : "",
};

export default function MemberFormModal({ open, onClose, onSubmit, isAdmin }) {
  const [form, setForm] = useState({
    name: "", email: "", username: "", password: "", whatsapp: "", address: "",
    kecamatan: KECAMATAN_MAGELANG[0], photo_path: "", role: "member",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const setField = (k, v) => {
    const next = { ...form, [k]: v }; setForm(next);
    if (RULES[k]) setErrors(prev => ({ ...prev, [k]: RULES[k](v) }));
  };
  const blur = (k) => setTouched(prev => ({ ...prev, [k]: true }));
  const err = (k) => (touched[k] || errors[k]) && errors[k];

  const save = () => {
    const errs = {}; Object.keys(RULES).forEach(k => { const m = RULES[k](form[k]); if (m) errs[k] = m; });
    setErrors(errs); setTouched(Object.fromEntries(Object.keys(RULES).map(k => [k, true])));
    if (Object.keys(errs).length) return;
    onSubmit(form);
  };

  if (!open) return null;
  return (
    <Modal open={open} onClose={onClose} title="Tambah Anggota Baru" testId="member-modal"
      footer={<>
        <button onClick={onClose} className="btn-outline flex-1" data-testid="cancel-member-btn">Batal</button>
        <button onClick={save} className="btn-primary flex-1" data-testid="save-member-btn"><Save size={16}/> Buat Akun</button>
      </>}>
      <div className="space-y-3">
        <Field label="Nama Lengkap *" error={err("name")}><input value={form.name} onChange={(e) => setField("name", e.target.value)} onBlur={() => blur("name")} className={cn(err("name"))} data-testid="new-member-name"/></Field>
        <Field label="Email *" error={err("email")}><input type="email" value={form.email} onChange={(e) => setField("email", e.target.value)} onBlur={() => blur("email")} className={cn(err("email"))} data-testid="new-member-email"/></Field>
        <Field label="Username (opsional)" error={err("username")}><input value={form.username} onChange={(e) => setField("username", e.target.value)} onBlur={() => blur("username")} className={cn(err("username"))} data-testid="new-member-username"/></Field>
        <Field label="Password (min 8) *" error={err("password")}><input type="password" value={form.password} onChange={(e) => setField("password", e.target.value)} onBlur={() => blur("password")} className={cn(err("password"))} data-testid="new-member-password"/></Field>
        <Field label="WhatsApp * (boleh awalan 0)" error={err("whatsapp")}><input value={form.whatsapp} onChange={(e) => setField("whatsapp", e.target.value)} onBlur={() => blur("whatsapp")} inputMode="tel" placeholder="0812xxx" className={cn(err("whatsapp"))} data-testid="new-member-wa"/></Field>
        <Field label="Alamat *" error={err("address")}><input value={form.address} onChange={(e) => setField("address", e.target.value)} onBlur={() => blur("address")} className={cn(err("address"))} data-testid="new-member-address"/></Field>
        <Field label="Kecamatan"><select value={form.kecamatan} onChange={(e) => setField("kecamatan", e.target.value)} className="input-bizma" data-testid="new-member-kec">{KECAMATAN_MAGELANG.map(k => <option key={k} value={k}>{k}</option>)}</select></Field>
        {isAdmin && (
          <Field label="Role"><select value={form.role} onChange={(e) => setField("role", e.target.value)} className="input-bizma" data-testid="new-member-role">
            <option value="member">Anggota</option>
            <option value="pengurus">Pengurus</option>
          </select></Field>
        )}
        <Field label="Foto Profil (opsional)"><PhotoUpload value={form.photo_path} onChange={(p) => setField("photo_path", p)} testId="new-member-photo"/></Field>
        <p className="text-xs text-bizma-subtext">Akun langsung dapat login. Email belum terverifikasi — anggota dapat verifikasi via halaman profil.</p>
      </div>
    </Modal>
  );
}

const cn = (hasErr) => `input-bizma ${hasErr ? "border-red-400 focus:border-red-500" : ""}`;
function Field({ label, error, children }) {
  return <div><label className="text-sm font-medium">{label}</label><div className="mt-2">{children}</div>{error && <div className="text-xs text-red-500 mt-1" data-testid="field-error">{error}</div>}</div>;
}
